export const TEAMS_DA = {
    "Sweden": "Sverige",
    "Norway": "Norge",
    "Brazil": "Brasilien",
    "North Macedonia": "Nordmakedonien",
    "Northern Ireland": "Nordirland",
    "Palestine": "Palæstina",
    "Iraq": "Irak",
    "Cameroon": "Cameroun",
    "Libya": "Libyen",
    "Estonia": "Estland",
    "Moldova": "Moldova",
    "Luxembourg": "Luxembourg",
    "Spain": "Spanien",
    "France": "Frankrig",
    "Germany": "Tyskland",
    "Italy": "Italien",
    "Belgium": "Belgien",
    "Slovakia": "Slovakiet",
    "Bulgaria": "Bulgarien",
    "Saudi Arabia": "Saudi-Arabien",
    "China PR": "Kina",
    "Australia": "Australien",
    "Korea Republic": "Sydkorea",
    "Jordan": "Jordan",
    "Indonesia": "Indonesien",
    "Kyrgyz Republic": "Kirgisistan",
    "South Africa": "Sydafrika",
    "Croatia": "Kroatien",
    "Czech Republic": "Tjekkiet",
    "Armenia": "Armenien",
    "Equatorial Guinea": "Ækvatorialguinea",
    "Morocco": "Marokko",
    "Poland": "Polen",
    "Romania": "Rumænien",
    "Latvia": "Letland",
    "Albania": "Albanien",
    "Algeria": "Algeriet",
    "Greece": "Grækenland",
    "Iceland": "Island",
    "Slovakia U21": "Slovakiet U21",
    "Spain U21": "Spanien U21",
    "Italy U21": "Italien U21",
    "Romania U21": "Rumænien U21",
    "France U21": "Frankrig U21",
    "Poland U21": "Polen U21",
    "Georgia U21": "Georgien U21",
    "Ukraine U21": "Ukraine U21",
    "Denmark U21": "Danmark U21",
    "Czech Republic U21": "Tjekkiet U21",
    "Germany U21": "Tyskland U21",
    "Slovenia U21": "Slovenien U21",
    "Netherlands U21": "Holland U21",
    "Dominican Republic": "Den Dominikanske Republik",
    "Suriname": "Surinam",
    "Mexico": "Mexico",
    "Canada": "Canada",
    "Denmark": "Danmark",
    "Netherlands": "Holland",
    "England": "England",
    "Scotland": "Skotland",
    "Wales": "Wales",
    "Republic of Ireland": "Irland",
    "Austria": "Østrig",
    "Switzerland": "Schweiz",
    "Portugal": "Portugal",
    "Hungary": "Ungarn",
    "Slovenia": "Slovenien",
    "Serbia": "Serbien",
    "Montenegro": "Montenegro",
    "Bosnia and Herzegovina": "Bosnien-Hercegovina",
    "Turkey": "Tyrkiet",
    "Georgia": "Georgien",
    "Lithuania": "Litauen",
    "Ukraine": "Ukraine",
    "Belarus": "Hviderusland",
    "Kazakhstan": "Kasakhstan",
    "Azerbaijan": "Aserbajdsjan",
    "Cyprus": "Cypern",
    "Malta": "Malta",
    "Andorra": "Andorra",
    "Liechtenstein": "Liechtenstein",
    "Egypt": "Egypten",
    "Tunisia": "Tunesien",
    "Senegal": "Senegal",
    "Ghana": "Ghana",
    "Guinea": "Guinea",
    "Burundi": "Burundi",
    "Madagascar": "Madagaskar",
    "Central African Republic": "Den Centralafrikanske Republik",
    "Côte d'Ivoire": "Elfenbenskysten",
    "Congo DR": "DR Congo",
    "Cape Verde Islands": "Kap Verde",
    "United States": "USA",
    "Panama": "Panama",
    "Guatemala": "Guatemala",
    "Honduras": "Honduras",
    "Nicaragua": "Nicaragua",
    "Haiti": "Haiti",
    "Argentina": "Argentina",
    "Uruguay": "Uruguay",
    "Chile": "Chile",
    "Bolivia": "Bolivia",
    "Peru": "Peru",
    "Paraguay": "Paraguay",
    "Venezuela": "Venezuela",
    "Colombia": "Colombia",
    "New Zealand": "New Zealand",
    "Iran": "Iran",
    "Syria": "Syrien",
    "Lebanon": "Libanon",
    "Yemen": "Yemen",
    "Kuwait": "Kuwait",
    "Oman": "Oman",
    "Bahrain": "Bahrain",
    "India": "Indien",
    "Thailand": "Thailand",
    "Singapore": "Singapore",
    "Hong Kong": "Hongkong",
    "Mongolia": "Mongoliet",
    "Uzbekistan": "Usbekistan",
    "Tajikistan": "Tadsjikistan",
    "Denmark W": "Danmark K",
    "Sweden W": "Sverige K",
    "Norway W": "Norge K",
    "Finland W": "Finland K",
    "Iceland W": "Island K",
    "England W": "England K",
    "Wales W": "Wales K",
    "Northern Ireland W": "Nordirland K",
    "Ireland W": "Irland K",
    "Netherlands W": "Holland K",
    "Belgium W": "Belgien K",
    "France W": "Frankrig K",
    "Germany W": "Tyskland K",
    "Austria W": "Østrig K",
    "Switzerland W": "Schweiz K",
    "Italy W": "Italien K",
    "Spain W": "Spanien K",
    "Portugal W": "Portugal K",
    "Poland W": "Polen K",
    "Czech Republic W": "Tjekkiet K",
    "Slovakia W": "Slovakiet K",
    "Slovenia W": "Slovenien K",
    "Serbia W": "Serbien K",
    "Ukraine W": "Ukraine K",
    "Türkiye W": "Tyrkiet K",
    "Faroe Islands": "Færøerne",
    "Mauritania": "Mauretanien",
    "Israel": "Israel",
    "Sierra Leone": "Sierra Leone",
    "Zimbabwe": "Zimbabwe",
    "Uganda": "Uganda",
}
